// extracted by mini-css-extract-plugin
module.exports = {"heading":"ModalHeadings_heading__2KIYb","subHeading":"ModalHeadings_subHeading__QFL0D"};